import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';
import { GetSignaturesResponseDTO } from './dto/brain-signatures.get.response.dto';
import { PostSignaturesResponseDTO } from './dto/brain-signatures.post.response.dto';

export class BrainAuthSignaturesService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/signatures`, client.getTimeout());
  }

  async get(request?: { settings?: RetrySettings }): Promise<GetSignaturesResponseDTO> {
    return (
      await this.client.get<GetSignaturesResponseDTO>(
        ``,
        {},
        {
          bearerToken: await getAuthToken(),
          settings: request?.settings,
        },
      )
    ).data;
  }

  async post(request?: { settings?: RetrySettings }): Promise<PostSignaturesResponseDTO> {
    return (
      await this.client.post<undefined, PostSignaturesResponseDTO>(``, undefined, {
        bearerToken: await getAuthToken(),
        settings: request?.settings,
      })
    ).data;
  }
}
